import { removeAuthToken, getAuthToken } from "../utils/auth";
import { config } from '../config';

export async function SignUpSession(signUpData) {
  const response = await fetch(config.apiBaseUrl + '/rest/users', {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(signUpData)
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return { status: response.status, data: (await response.json()) }
}

export async function SignInSession(signInData) {
  const response = await fetch(config.apiBaseUrl + '/rest/sessions', {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(signInData)
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return { status: response.status, data: (await response.json()) }
}

export async function SignOutSession() {
  const response = await fetch(config.apiBaseUrl + '/rest/sessions', {
    method: 'DELETE',
    headers: {
      'content-type': 'application/json',
      'Authorization': 'Bearer ' + getAuthToken()
    }
  })

  if (!response.ok) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  removeAuthToken()

  return true
}

export async function GoogleSignInSession(data) {
  const response = await fetch(config.apiBaseUrl + '/rest/session_google', {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(data)
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return { status: response.status, data: (await response.json()) }
}

export async function AppleSignInSession(data) {
  const response = await fetch(config.apiBaseUrl + '/rest/session_apple', {
    method: 'POST',
    headers: {
      'content-type': 'application/json'
    },
    body: JSON.stringify(data)
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return { status: response.status, data: (await response.json()) }
}

export async function GetCurrentUserDataSession(token) {
  // Accept an explicit token (used right after sign-in, before it is persisted)
  // and otherwise fall back to the stored token.
  const authToken = token || getAuthToken()

  const response = await fetch(config.apiBaseUrl + '/rest/sessions/current_user', {
    headers: {
      'content-type': 'application/json',
      'Authorization': 'Bearer ' + authToken
    }
  })

  if (response.status >= 500) {
    throw Response.json({ message: 'Something went wrong' }, { status: 500 })
  }

  return { status: response.status, data: (await response.json()) }
}